import React from "react";
import styled, { css } from "styled-components";
import { Alert } from "components/bootstrap";
import useCurrentUser from "hooks/useCurrentUser";
import StringUtils from "util/StringUtils";
import DocsHelper from "util/DocsHelper";
import DocumentationLink from "components/support/DocumentationLink";
import { Icon, TextOverflowEllipsis } from "components/common";
import getInaccessibleFiltersFromView from "search-filter/logic/getInaccessableFiltersFromView";
import useView from "views/hooks/useView";
const StyledAlert = styled(Alert)`
  margin-bottom: 10px;
  ${(props) => props.$isCompact && css`
      padding: 7px 10px;
    `}
`;
const FilterList = styled.ul`
  padding-left: 20px;
  overflow: auto;
  ${(props) => css`
    max-height: ${props.$isCompact ? "52px" : "100px"};
  `}

  li {
    list-style: initial;
  }
`;
const SearchFilterTransformationWarning = ({ disabledViewCreation = false, isCompact = false }) => {
  const user = useCurrentUser();
  const view = useView();
  if (disabledViewCreation) {
    return null;
  }
  const inaccessibleSearchFilters = getInaccessibleFiltersFromView(view, user.permissions);
  if (!(inaccessibleSearchFilters == null ? void 0 : inaccessibleSearchFilters.size)) {
    return null;
  }
  const pluralizedFilter = StringUtils.pluralize(inaccessibleSearchFilters.size, "filter", "filters");
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning", $isCompact: isCompact }, "A copy for ", inaccessibleSearchFilters.size, " referenced search ", pluralizedFilter, " will be created, because of missing permissions. ", /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.WELCOME, text: /* @__PURE__ */ React.createElement(Icon, { name: "lightbulb_circle" }) }), /* @__PURE__ */ React.createElement(FilterList, null, inaccessibleSearchFilters.toArray().map((filter) => /* @__PURE__ */ React.createElement("li", { key: filter.id }, /* @__PURE__ */ React.createElement(TextOverflowEllipsis, null, filter.title || filter.queryString)))));
};
export default SearchFilterTransformationWarning;
